var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"ma-0"},_vm._l((_vm.items),function(item,index){return _c('v-checkbox',{key:index,staticClass:"mt-1 mr-5",attrs:{"value":item.text,"label":item.text,"hide-details":"auto"},on:{"change":_vm.changeValue},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }